module.exports = __webpack_public_path__ + "media/images/payments/paysafecard-dark-e353adcbfbd67939a3c4ac2d85876bb1.svg";